import { CapacitorHttp, HttpOptions, HttpResponse } from '@capacitor/core';
import { getAuthenticationToken } from 'src/shared/utils/getAuthenticationToken';

interface IHttpResponseData<T> extends Omit<HttpResponse, 'data'> {
  data: T;
}

export const HttpHandler = async <T = any>(options: HttpOptions) => {
  const token = await getAuthenticationToken();

  const successCodeStatuses = [200, 201, 203, 204, 205, 206, 207, 208, 226];
  const response: IHttpResponseData<T> = await CapacitorHttp.request({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options?.headers,
    },
  });
  if (successCodeStatuses.includes(response.status)) {
    return Promise.resolve(response);
  } else {
    return Promise.reject(response.data);
  }
};
